export const VIEW_KEY = 'view';
export const LIKE_KEY = 'like';
export const SHARE_KEY = 'share';

export const configurationSvgSizes = [
  'x5Small',
  'x4Small',
  'x3Small',
  'x2Small',
  'xSmall',
  'small',
  'medium',
  'large',
  'xLarge',
  'x2Large',
  'x3Large',
  'x4Large',
  'x5Large',
  'x6Large',
  'x7Large',
  'x8Large',
  'x9Large',
] as const;

export const CUSTOM_CONFIGURATION_OPTION_PREFIX = '_$_' as const;
